import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sentences__wrapper" }
const _hoisted_2 = { class: "sentences" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "Составьте предложения со словами", -1)
const _hoisted_4 = ["onKeydown"]
const _hoisted_5 = {
  key: 0,
  class: "sentences__stats"
}
const _hoisted_6 = {
  key: 0,
  class: "sentences__error sentences__error-null"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Вы допустили ошибку в слове", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "sentences__error sentences__error-first"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "Все верно !", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 2,
  class: "sentences__error sentences__error-second"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, "Слишком маленькое предложение", -1)
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentWords, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.russian,
          class: "sentences__item"
        }, [
          _createElementVNode("h3", null, _toDisplayString(item.russian) + " -", 1),
          _createElementVNode("textarea", {
            class: "input-focus",
            ref_for: true,
            ref: el => { if (el) _ctx.sentences[index] = el },
            rows: "1",
            onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.checkItem(index)), ["prevent"]), ["enter"])
          }, null, 40, _hoisted_4),
          (_ctx.doneList.value[index].english == item.english)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_ctx.doneList.value[index].isDone == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
                  : _createCommentVNode("", true),
                (_ctx.doneList.value[index].isDone == 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                  : _createCommentVNode("", true),
                (_ctx.doneList.value[index].isDone == 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      _createElementVNode("button", {
        class: "profile__run sentences__finish",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/account')))
      }, "Завершить")
    ])
  ]))
}